import React from 'react';
import { X, Plane } from 'lucide-react';

const AddFlightModal = ({
  isOpen,
  onClose,
  flightForm,
  setFlightForm,
  onSave
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-gray-900 border border-gray-700 rounded-2xl w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        <div className="px-6 py-4 border-b border-gray-700 flex items-center justify-between">
          <h3 className="text-lg font-bold text-white flex items-center gap-2">
            <Plane size={20} className="text-cyan-400" /> Add to Flights
          </h3>
          <button onClick={onClose} className="p-1 hover:bg-gray-800 rounded-full">
            <X size={18} className="text-gray-400" />
          </button>
        </div>
        <div className="p-6 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Airline</label>
              <input 
                data-testid="flight-airline" 
                value={flightForm.airline} 
                onChange={e => setFlightForm({...flightForm, airline: e.target.value})} 
                className="w-full bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 focus:border-cyan-500 focus:outline-none" 
                placeholder="e.g. American Airlines" 
              />
            </div>
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Flight #</label>
              <input 
                data-testid="flight-number" 
                value={flightForm.flight_number} 
                onChange={e => setFlightForm({...flightForm, flight_number: e.target.value})} 
                className="w-full bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 focus:border-cyan-500 focus:outline-none" 
                placeholder="e.g. AA1234" 
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Departure</label>
              <input 
                data-testid="flight-departure" 
                value={flightForm.departure} 
                onChange={e => setFlightForm({...flightForm, departure: e.target.value})} 
                className="w-full bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 focus:border-cyan-500 focus:outline-none" 
                placeholder="e.g. Dallas, TX" 
              />
            </div>
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Arrival</label>
              <input 
                data-testid="flight-arrival" 
                value={flightForm.arrival} 
                onChange={e => setFlightForm({...flightForm, arrival: e.target.value})} 
                className="w-full bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 focus:border-cyan-500 focus:outline-none" 
                placeholder="e.g. New York, NY" 
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Date</label>
              <input 
                data-testid="flight-date" 
                type="date" 
                value={flightForm.date} 
                onChange={e => setFlightForm({...flightForm, date: e.target.value})} 
                className="w-full bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 focus:border-cyan-500 focus:outline-none" 
              />
            </div>
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Time</label>
              <input 
                data-testid="flight-time" 
                type="time" 
                value={flightForm.time} 
                onChange={e => setFlightForm({...flightForm, time: e.target.value})} 
                className="w-full bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 focus:border-cyan-500 focus:outline-none" 
              />
            </div>
          </div>
          <div>
            <label className="text-xs text-gray-400 mb-1 block">Notes</label>
            <textarea 
              data-testid="flight-notes" 
              value={flightForm.notes} 
              onChange={e => setFlightForm({...flightForm, notes: e.target.value})} 
              rows={3} 
              className="w-full bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 focus:border-cyan-500 focus:outline-none resize-none" 
              placeholder="Additional details..." 
            />
          </div>
          <button 
            data-testid="save-flight-btn" 
            onClick={onSave} 
            className="w-full py-2.5 bg-cyan-600 hover:bg-cyan-500 text-white rounded-lg font-medium transition-colors flex items-center justify-center gap-2"
          >
            <Plane size={16} /> Add Flight
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddFlightModal;
